import { Fragment, Node as ProseMirrorNode } from '@tiptap/pm/model';

const mapFragment = (fragment: Fragment, callback: (node: ProseMirrorNode) => ProseMirrorNode): Fragment => {
  const mapped: ProseMirrorNode[] = [];
  fragment.forEach((child) => {
    child = callback(child);
    if (child.isLeaf) {
      mapped.push(child);
    } else {
      mapped.push(child.copy(mapFragment(child.content, callback)));
    }
  });
  return Fragment.fromArray(mapped);
};

export default mapFragment;
